import './CrossProductsCarousel.scss';

import { Image } from 'antd';
import Carousel, { CarouselRef } from 'antd/es/carousel';
import classNames from 'classnames';
import React, { useEffect,useRef, useState } from 'react';

interface Props {
    veri: any;
}

const CrossProductsCarousel = ({ veri }: Props) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const carouselRef = useRef<CarouselRef>(null);
    const classes = classNames('cross-products-carousel');

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.goTo(0);
        }
    }, [veri]); // Yeni veri geldiğinde resetle

    if (!veri || !veri.urun || !veri.urun.resimler) {
        return null;
    }

    const images: string[] = Array.isArray(veri.urun.resimler) ? veri.urun.resimler : [];
    const handleImageClick = (index: number) => {
        setActiveIndex(index);
        if (carouselRef.current) {
            carouselRef.current.goTo(index);
        }
    };

    const handleCarouselChange = (currentIndex: number) => {
        setActiveIndex(currentIndex);
    };
    return (
        <div className={classes}>
            <Carousel className="cross-products-carousel carousel-container" draggable dots={false} ref={carouselRef} afterChange={handleCarouselChange}>
                {images.map((resim: string, index: number) => (
                    <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                        <Image
                            preview={true}
                            className="image-still"
                            src={resim || process.env.NX_NO_IMAGE_URL}
                            alt="ürün detay"
                            onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                                const target = e.target as HTMLImageElement;
                                target.src = process.env.NX_NO_IMAGE_URL!;
                            }}
                        />
                    </div>
                ))}
            </Carousel>
            <div className="custom-cross-product-indicators">
                <Image.PreviewGroup>
                    {images.map((image, index) => (
                        <Image
                            preview={false}
                            width={50}
                            height={50}
                            key={index}
                            className={`${index === activeIndex ? 'active' : 'non-active'} `}
                            src={image || process.env.NX_NO_IMAGE_URL}
                            alt="ürün detay"
                            onClick={() => handleImageClick(index)}
                            onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                                const target = e.target as HTMLImageElement;
                                target.src = process.env.NX_NO_IMAGE_URL!;
                            }}
                        />
                    ))}
                </Image.PreviewGroup>
            </div>
        </div>
    );
};

export default CrossProductsCarousel;
